import { useTranslation } from "react-i18next";
import { Button } from "@components/Button";
import { parseHtml } from "@components/HTMLParser/utils";
import { Modal } from "@components/Modal/Modal";
import { useModal } from "@hooks/useModal";
import { type IUseModalProps } from "@store/modal/modal";

interface IPaymentRestrictionModalProps extends IUseModalProps {
  title: string;
  description: string;
}

export const PaymentRestrictionModal: React.FC<
  IPaymentRestrictionModalProps
> = (props) => {
  const { title, description, ...rest } = props;
  const modal = useModal(rest);
  const { t } = useTranslation();

  return (
    <Modal
      modal={modal}
      title={title}
      actionButtons={
        <>
          <Button className="w-full" variant="secondary" onClick={modal.close}>
            {t("KYCWarningModal.buttons.cancel")}
          </Button>
        </>
      }
    >
      <p>{parseHtml(description)}</p>
    </Modal>
  );
};
